import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { TableContainer, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MAP_TO_AREA, MAKE_AND_MAP_AREA } from '../../hasura/queries/area/areaMapping';
import { ClaimFilters } from '../../components/claim/claimFilters';
import { EntityLinkTable } from '../table/entityLinkTable';
import { AREA_CLAIM_TO_MAP_SCHEMA } from '../../schema/areaSchema';
import { RepeatableError } from '../util/notifications';
import { mutationError } from '../graphql/util';
import ClaimMappingButtons from '../mapping/claimMappingButtons';
import { SimilarEntity } from '../mapping/SimilarEntity';
import { SIMILAR_AREAS } from '../../hasura/queries/area/areas';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),

    '& h3': {
      paddingLeft: 5,
    },
    '& button': {
      margin: '10px 5px',
      float: 'right',
    },
    '& tr': {
      cursor: 'pointer',
      '&.active': {
        backgroundColor: theme.palette.secondary.dark,
      },
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  },
}));
const AreaMapping = props => {
  const classes = useStyles();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState(null);
  const [areaMapViewState, setAreaMapViewState] = useState({
    claimFilter: 'all',
    selectedClaim: null,
    selectedSim: null,
  });

  const filterResults = claimFilter => {
    setAreaMapViewState({
      ...areaMapViewState,
      claimFilter,
    });
  };

  const filterClaims = claims => {
    if (areaMapViewState.claimFilter === 'undecided') {
      return claims.filter(c => c.approved_at === null && c.rejected_at === null);
    } else if (areaMapViewState.claimFilter === 'approved') {
      return claims.filter(c => c.approved_at != null);
    } else if (areaMapViewState.claimFilter === 'rejected') {
      return claims.filter(c => c.rejected_at != null);
    } else {
      return claims;
    }
  };

  const selectClaim = selectedClaim => {
    setAreaMapViewState({
      ...areaMapViewState,
      selectedClaim,
    });
  };

  const selectSimilarArea = selectedSim => {
    setAreaMapViewState({
      ...areaMapViewState,
      selectedSim,
    });
  };

  const filteredClaims = filterClaims(props.claims);

  const returnToClaimsList = () => {
    history.push('/claims/area');
  };

  const [mapToArea] = useMutation(MAP_TO_AREA, {
    onError: err => setErrorMessage(mutationError(err, 'Problem Mapping Area Claim to Statsbomb Area')),
    onCompleted: returnToClaimsList,
  });

  const [makeAndMapArea] = useMutation(MAKE_AND_MAP_AREA, {
    onError: err => setErrorMessage(mutationError(err, 'Problem Creating Statsbomb Area and Mapping it to the Claim')),
    onCompleted: returnToClaimsList,
  });

  const selClaim = props.claims.filter(c => c.claim_area_uuid === areaMapViewState.selectedClaim)[0] || {};

  const createAreaMapFn = async e => {
    e.preventDefault();
    try {
      await mapToArea({
        variables: {
          area_id: areaMapViewState.selectedSim,
          provider: selClaim.provider,
          provider_area_id: selClaim.provider_area_id,
        },
      });
    } catch (err) {
      console.error({ 'mapping failed': err });
    }
  };

  const createAreaAndMapFn = async e => {
    e.preventDefault();
    try {
      await makeAndMapArea({
        variables: {
          area_name: selClaim.area_name,
          provider: selClaim.provider,
          provider_area_id: selClaim.provider_area_id,
        },
      });
    } catch (err) {
      console.error({ 'mapping failed': err });
    }
  };

  return (
    <>
      <div className="container-row">
        <h2>Unmapped Area Mapper. Provider Area Id: {props.provider_area_id}</h2>
        <h3>Select A Claim to view Possible Areas</h3>
        <TableContainer component={Paper}>
          <ClaimFilters claimFilter={areaMapViewState.claimFilter} filterResultsFn={filterResults} />

          <EntityLinkTable
            entities={filteredClaims}
            schema={AREA_CLAIM_TO_MAP_SCHEMA}
            rowClickHandler={claim => {
              selectClaim(claim.claim_area_uuid);
            }}
            entityKey="claim_area_uuid"
            selectedEntityKey={areaMapViewState?.selectedClaim}
          />
        </TableContainer>

        {areaMapViewState.selectedClaim && (
          <TableContainer component={Paper} classes={classes}>
            <SimilarEntity
              provider="Soccerway"
              entityName={selClaim.area_name}
              selectSimilarEntityFn={selectSimilarArea}
              selectedSim={areaMapViewState.selectedSim}
              type="area"
              query={SIMILAR_AREAS}
            />

            <ClaimMappingButtons
              displayName="Area"
              claim={selClaim}
              similarRecord={areaMapViewState.selectedSim}
              schema={[]}
              mapEntityFn={createAreaMapFn}
              createNewEntityFn={createAreaAndMapFn}
            />
          </TableContainer>
        )}
      </div>
      <RepeatableError message={errorMessage} setMessage={setErrorMessage} />
    </>
  );
};

export { AreaMapping };
